export default {
  meta: {
    title: $localize`:@@meta.raffles.title:Розыгрыши и раздачи CS2`
  }
};
